import { render } from "./whatsAppMarketing.vue?vue&type=template&id=41b8b2f2&scoped=true"
import script from "./whatsAppMarketing.vue?vue&type=script&lang=js"
export * from "./whatsAppMarketing.vue?vue&type=script&lang=js"

import "./whatsAppMarketing.vue?vue&type=style&index=0&id=41b8b2f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41b8b2f2"]])

export default __exports__